import { type BaseOptionsType } from 'advanced-filters/data';

export interface ConditionKeyOptionsType extends BaseOptionsType {
  optionTitle?: string;
}

export const transformOptionsForSelect = (options: ConditionKeyOptionsType[]) => {
  const groupedOptions = options.reduce((acc, option) => {
    const title = option.optionTitle ?? '';
    if (!acc[title]) acc[title] = [];
    acc[title].push(option);
    return acc;
  }, {} as Record<string, ConditionKeyOptionsType[]>);

  return [
    ...groupedOptions[''] ?? [],
    ...Object.entries(groupedOptions)
      .filter(([title]) => title !== '')
      .map(([title, children]) => ({
        label: title,
        options: children.map(({ label, value }) => ({ label, value })),
      })),
  ];
};
